'use client';
import LogoutIcon from '@hc-frontend/core-icons/kit/logout';
import { Button } from '@hc-frontend/core-ui';
import { signOut } from 'next-auth/react';

import type { LogoutProps } from './logout.types';

export function Logout({ children, ...props }: LogoutProps) {
  return (
    <Button
      type="button"
      variant="text"
      onClick={() =>
        signOut({
          callbackUrl: '/?logout=true',
        })
      }
      icon={<LogoutIcon className="hc-typography--heading-three" />}
      {...props}
    >
      {children}
    </Button>
  );
}
